import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { List, Map, Record } from 'immutable';
import maxContent from '../util/maxContent';
import { addValidator, validate } from 'instructure-validations';
addValidator('maxContent', maxContent);
export function mixinBaseRecord(schema) {
  return /*#__PURE__*/function (_Record) {
    function BaseRecord() {
      _classCallCheck(this, BaseRecord);
      return _callSuper(this, BaseRecord, arguments);
    }
    _inherits(BaseRecord, _Record);
    return _createClass(BaseRecord, [{
      key: "getErrors",
      value: function getErrors() {
        var objectToValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
        return this.errors.merge(validate(objectToValidate.toJS(), this.constructor.validations));
      }
    }, {
      key: "isValid",
      value: function isValid() {
        var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
        var errors = this.getErrors();
        if (errors.size === 0) {
          return true;
        }
        return !errors.find(function (val) {
          return val.size > 0;
        });
      }
    }, {
      key: "errorsFor",
      value: function errorsFor(attr) {
        // only for top-level attributes
        // use errorsIn for nested errors
        return this.errorsIn([attr]);
      }
    }, {
      key: "errorsIn",
      value: function errorsIn(nodes) {
        return this.getErrors().getIn(nodes, List());
      }
    }, {
      key: "validData",
      value: function validData() {
        var errors = this.getErrors();
        return this.toMap()["delete"]('errors').filter(function (attrVal, key) {
          return !errors.has(key);
        });
      }
    }], [{
      key: "validations",
      value:
      // ====================
      // ====================
      // VALIDATION & ERRORS
      // ====================
      // ====================

      function validations() {
        return {};
      }
    }, {
      key: "create",
      value: function create(attrs) {
        this.recordCache = this.hasOwnProperty('recordCache') ? this.recordCache : new WeakMap();
        var recordCache = this.recordCache;
        if (attrs && typeof attrs === 'object' && recordCache.has(attrs)) {
          return recordCache.get(attrs);
        }
        var newRecord = new this(attrs);
        if (attrs && typeof attrs === 'object') {
          recordCache.set(attrs, newRecord);
        }
        return newRecord;
      }
    }]);
  }(Record(_objectSpread({
    errors: Map()
  }, schema)));
}
export default mixinBaseRecord;